"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@fontsource/open-sans/300.css");
require("@fontsource/open-sans/300-italic.css");
require("@fontsource/open-sans/400.css");
require("@fontsource/open-sans/400-italic.css");
require("@fontsource/open-sans/600.css");
require("@fontsource/open-sans/600-italic.css");
require("@fontsource/open-sans/700.css");
require("@fontsource/open-sans/700-italic.css");
require("@fontsource/open-sans/800.css");
require("@fontsource/open-sans/800-italic.css");
